import axios from 'axios'
import axiosRetry from 'axios-retry'

const config = axios.create({
  baseURL: IPVM_URL,
  withCredentials: true
})

axiosRetry(config, {
  retries: 0,
  retryCondition: axiosRetry.isRetryableError,
  retryDelay: axiosRetry.exponentialDelay
})

export default config



// WEBPACK FOOTER //
// ./src/api/config.js